import { EXPAND_FIELD } from '../type_name'
import { Icon } from 'view-design'
import { VBtn } from 'vuetify/lib'
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: EXPAND_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        },
        target: {
            type: [Object]
        },
        expands: {
            type: [Array]
        },
        addExchange: {
            type: Function,
        },
        delExchange: {
            type: Function,
        }
    },
    mounted() {
        
    },
    methods:{
        changeStatus() {
            if (!this.expands.includes(this.target)) {
                this.addExchange(this.target)
                return 
            }
            this.delExchange(this.target)
        }
    },
    render() {
        return <span>
            <VBtn 
                x-small
                text
                on-click={this.changeStatus}
            >
                <Icon type={this.expands.includes(this.target) ? 'ios-arrow-down' : 'ios-arrow-forward'}/>
            </VBtn>
        </span> 
        
    }
}